import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";

export const HasPermission = ({ permissionsToCheck, children }) => {

  const [hasAllPermission, setHasAllPermission] = useState(false);

  const permissions = useSelector(state=>state?.context?.permissions?.map((perm) => perm.identifier));

  useEffect(() => {
    if (permissions && permissionsToCheck) {
      const oneOrMoreItemsWithNoPermission = permissionsToCheck.find(
        (item) => !permissions.includes(item)
      );

      setHasAllPermission(!oneOrMoreItemsWithNoPermission);
    }
  }, [permissions, permissionsToCheck]);

  if (hasAllPermission) {
    return <div>{children}</div>;
  }
  return <div />;
};

HasPermission.propTypes = {
  permissionsToCheck: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
};
